



























































import Vue from 'vue';
import SettingsUser from '@/components/SettingsUser.vue';
import SettingsUsers from '@/components/SettingsUsers.vue';
import SettingsUserGroups from '@/components/SettingsUserGroups.vue';
import SettingsPlaces from '@/components/SettingsPlaces.vue';
import SettingsTerminals from '@/components/SettingsTerminals.vue';

export default Vue.extend({
  name: 'SettingsView',
  components: {
    user: SettingsUser,
    users: SettingsUsers,
    userGroups: SettingsUserGroups,
    places: SettingsPlaces,
    terminals: SettingsTerminals,
  },
  data: () => ({
    currentComponent: 'user',
  }),
  methods: {
    swapComponent(component: string) {
      this.currentComponent = component;
    },
  },
});
